import { AppConfig } from '@interfaces/app-config.interface';
import { sidebarConfigItem } from '@interfaces/sidebar.interface';
import { Permission, PermissionType } from '@json/src/app/enums/PermissionType';
import { Utils } from '@json/src/app/Utils';

export const appConfig: AppConfig = {
  origin: 'hospital',
  // origin: 'pharma',
};

// Side menu config
export const sidebarConfig: sidebarConfigItem[] = [
  { link: 'welcome', label: 'Inicio', type: 'link', iconName: 'home' ,hasPermission: [PermissionType.READ, PermissionType.WRITE] },
  { link: 'patients', label: 'Residentes', type: 'link', iconName: 'group', hasPermission: Utils.hasPermission(Permission.PATIENTS) },
  {
    link: 'institutions',
    label: 'Centros',
    type: 'link',
    iconName: 'apartment',
    hasPermission: Utils.hasPermission(Permission.INSTITUTIONS)
  },
  {
    link: 'medicines',
    label: 'Vademecum',
    type: 'link',
    iconName: 'medication',
    hasPermission: Utils.hasPermission(Permission.VADEMECUM)
  },
  {
    link: 'stock',
    label: 'Inventario',
    iconName: 'workspaces',
    type: 'menu',
    hasPermission: Utils.hasPermission(Permission.VADEMECUM),
    items: [
      {
        link: 'stock/list',
        label: 'Inventario',
        type: 'link',
        iconName: '',
        hasPermission: Utils.hasPermission(Permission.VADEMECUM)
      },
      {
        link: 'stock/suppliers',
        label: 'Proveedores',
        type: 'link',
        iconName: '',
        hasPermission: Utils.hasPermission(Permission.VADEMECUM)
      },
      {
        link: 'stock/invoices',
        label: 'Albaranes',
        type: 'link',
        iconName: '',
        hasPermission: Utils.hasPermission(Permission.VADEMECUM)
      }
    ]
  },

  //README: Path names are taken from demo.corota.net
  {
    link: 'reports',
    label: 'Reportes',
    iconName: 'library_books',
    type: 'menu',
    hasPermission: Utils.hasPermission(Permission.REPORTS),
    items: [
      {
        link: 'reports',
        label: 'Gestión de pacientes',
        iconName: 'group',
        type: 'menu',
        hasPermission: Utils.hasPermission(Permission.REPORTS_PATIENTS),
        items: [
          {
            link: 'reports/pathmeds',
            label: 'Consumo por pacientes',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_PATIENTS)
          },
          {
            link: 'reports/patientlist',
            label: 'Listado de pacientes',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_PATIENTS)
          },
          {
            link: 'reports/patchgs',
            label: 'Movimientos de pacientes',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_PATIENTS)
          },
        ],
      },
      {
        link: 'reports',
        label: 'Gestión residencial',
        iconName: 'apartment',
        type: 'menu',
        hasPermission: Utils.hasPermission(Permission.REPORTS_RESI),
        items: [
          {
            link: 'reports/mednostock',
            label: 'Medicamentos faltantes',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_RESI)
          },
          {
            link: 'reports/meddangerous',
            label: 'Medicamentos peligrosos',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_RESI)
          },
        ],
      },
      {
        link: 'reports',
        label: 'Gestión farmacia',
        iconName: 'local_pharmacy',
        type: 'menu',
        hasPermission: Utils.hasPermission(Permission.REPORTS_FARMA),
        items: [
          {
            link: 'reports/billing',
            label: 'Facturación',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_FARMA),
          },
          {
            link: 'reports/purchases',
            label: 'Compras',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_FARMA),
          },
          {
            link: 'reports/severes',
            label: 'Agudos',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_FARMA),
          },
          {
            link: 'reports/instmed',
            label: 'Medicinas por institucion',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_FARMA),
          },
          {
            link: 'reports/patboxes',
            label: 'Caja por pacientes',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_FARMA),
          },
          {
            link: 'reports/obsomeds',
            label: 'Obsolescencia',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_FARMA),
          },
          {
            link: 'reports/estupef',
            label: 'Estupefacientes',
            type: 'link',
            iconName: '',
            hasPermission: Utils.hasPermission(Permission.REPORTS_FARMA),
          }
        ],
      },
    ],
  },
];
